import { REHYDRATE } from 'redux-persist'
import { constants } from '../constants/redux-constants'

const initialState = {
    surveyUser:{}
}

const SurveyReducer = (state = initialState, action) => {
    switch (action.type) {
        case REHYDRATE:
            return {
                ...state,
                ...(action.payload?.surveyUser || {}),
            }
        case constants.RESET:
            return {
                ...initialState,
            }
        case constants.SURVEY?.SET_SURVEY_USER:
            return {
                ...state,
                surveyUser: action.payload,
            }
        default:
            return {
                ...state,
            }
    }
}

export default SurveyReducer
